// import Top from './top';
import Product from './product';
import ProductSearch from './productsearch';
import SingleProduct from './singleProduct';

class Views {
  init() {
    // const hasHomeElement = document.querySelector('[data-home]');
    const subpageElement = document.querySelector('[data-subpage]');

    // top
    // if (hasHomeElement !== null || subpageElement === null) {
    //   const top = new Top();
    //   top.init();
    // }

    // subpage
    if (subpageElement !== null) {
      const pageSlug = subpageElement.getAttribute('data-page');

      switch (pageSlug) {

        // product page
        case 'product':
          const product = new Product();
          product.init();
          break;

        // productSearch page
        case 'search':
          const productsearch = new ProductSearch();
          productsearch.init();
          break;

        default:
          break;
      }
    }
    
    const pageElement = document.querySelector('[data-page]');
    if (pageElement !== null) {
      const pageSlug = pageElement.getAttribute('data-page');
      switch (pageSlug) {
        case 'single-product':
          const singleProduct = new SingleProduct();
          singleProduct.init();
          break;

        default:
          break;
      }
    }
    
  }
}

export default Views;


// // メニューを開く関数
// const slideDown = (el) => {
//   el.style.height = 'auto'; //いったんautoに
//   let h = el.offsetHeight; //autoにした要素から高さを取得
//   el.style.height = h + 'px';
//   el.animate([ //高さ0から取得した高さまでのアニメーション
//     { height: 0 },
//     { height: h + 'px' }
//   ], {
//     duration: 300, //アニメーションの時間（ms）
//    });
// };

// // メニューを閉じる関数
// const slideUp = (el) => {
//   el.style.height = 0;
// };

// let activeIndex = null; //開いているアコーディオンのindex

// //アコーディオンコンテナ全てで実行
// const accordions = document.querySelectorAll('ul.qa-lists');
// accordions.forEach((accordion) => {

//   //アコーディオンボタン全てで実行
//   const accordionBtns = accordion.querySelectorAll('.qa-q');
//   accordionBtns.forEach((accordionBtn, index) => {
//     accordionBtn.addEventListener('click', (e) => {
//       activeIndex = index; //クリックされたボタンを把握
//       e.target.parentNode.classList.toggle('active'); //ボタンの親要素（=ul>li)にクラスを付与／削除
//       const content = accordionBtn.nextElementSibling; //ボタンの次の要素（=ul>ul）
//       if(e.target.parentNode.classList.contains('active')){
//         slideDown(content); //クラス名がactive（＝閉じていた）なら上記で定義した開く関数を実行
//       }else{
//         slideUp(content); //クラス名にactiveがない（＝開いていた）なら上記で定義した閉じる関数を実行
//       }
//       accordionBtns.forEach((accordionBtn, index) => {
//         if (activeIndex !== index) {
//           accordionBtn.parentNode.classList.remove('active');
//           const openedContent = accordionBtn.nextElementSibling;
//           slideUp(openedContent); //現在開いている他のメニューを閉じる
//         }
//       });
//       //スクロール制御のために上位階層ulのクラス名を変える
//       let container = accordion.closest('.scroll-control'); //sroll-controlnのクラス名である親要素を取得
//       if(accordionBtn.parentNode.classList.contains('active') == false && container !== null ){
//         container.classList.remove('active')
//       }else if (container !== null){
//         container.classList.add('active')
//       }
//     });
//   });
// });

const buttons = document.querySelectorAll('.qa-q');

buttons.forEach((button) => {
  button.addEventListener('click', (e) => {
    const body = e.currentTarget.nextElementSibling;
    const text = body.children[0];
    const textHeight = text.offsetHeight;

    const menu = e.currentTarget.parentNode;
    menu.classList.toggle('open');

    if(menu.classList.contains('open')) {
      body.style.height = textHeight + 'px';
    } else {
      body.style.height = 0;
    }
  });
});
